import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { EditorActor } from 'src/app/models/requestEditor';
import { DocumentActor } from 'src/app/models/actors';
import { Subscription } from 'rxjs';
import { ExistsIn, SingleOrDefault } from 'src/app/_helpers/ArrayExtensionMethodHelper.functions';
import { ActorActionEnum } from 'src/app/constants/actor-action.enum';
import { RequestStatusService } from '../../requeststatus.service';
import { UpdateExistingRequestActorModel } from 'src/app/models/api/update-existing-actor.model';

@Component({
  selector: 'requests-to-update-list',
  styleUrls: ['./checklist-requests.component.css'],
  templateUrl: './checklist-requests.component.html'
})
export class ChecklistRequestsComponent {
    public requests: UpdateExistingRequestActorModel[] = [];
    @Input() set requestsToUpdate(val: UpdateExistingRequestActorModel[]) {
        val.forEach(requestToUpdate => {
            requestToUpdate.checked = true;
        });
        this.requests = val;
    };
    @Output() selectedRequests: EventEmitter<UpdateExistingRequestActorModel[]> = new EventEmitter<UpdateExistingRequestActorModel[]>();


    constructor() {

    }

    toggle(requestId: string) {
        let request = SingleOrDefault(this.requests, "requestGuid", requestId);
        if(request && !request.checked){
            if(request) {
                request.checked = true;
            }
        } else {
            if(request) {
                request.checked = false;
            }
        }

        this.selectedRequests.emit(this.requests);
    }
}
